<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="450" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Form Reset Password Pelanggan</v-card-title>
				<v-card-text>
					<v-form ref="formLogin" role="form" v-model="form" @submit.prevent="simpan">
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-text-field :type="inputType" outlined dense v-model="customer_password" :rules="passwordRules" @focus="() => responseError.customer_password=''" :error-messages="responseError.customer_password" label="Password baru pelanggan" hint="Password baru pelanggan" :append-icon="iconPass" @click:append="showPassword"></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-text-field :type="inputTypeConfirmation" outlined dense v-model="customer_password_confirmation" :rules="passwordRules" @focus="() => responseError.customer_password_confirmation=''" :error-messages="responseError.customer_password_confirmation" label="Konfirmasi password baru" hint="Konfirmasi password baru" :append-icon="iconPass" @click:append="showPasswordConfirmation"></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Reset Password</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			form: true,
			dialog: false,
			passwordRules: [
			value => !!value || 'Password tidak boleh kosong',
			],
			customer_password: '',
			customer_password_confirmation: '',
			inputType: 'password',
			inputTypeConfirmation: 'password',
			customer_network_mid: '',
			iconPass: 'mdi-eye',
		}
	},
	computed: {
		...mapState('customerList', ['responseError']),
	},
	methods: {

		async showModal(customer_network_mid) {
			this.dialog = await true
			this.iconPass = await 'mdi-eye'
			this.inputType = await 'password'
			await this.$refs.formLogin.resetValidation()
			this.customer_password = await ''
			this.customer_network_mid = await customer_network_mid
		},
		hideModal() {
			this.dialog = false
		},
		batal() {
			this.hideModal()
		},
		simpan() {
			if (this.$refs.formLogin.validate()) {
				let params = {
					customer_password: this.customer_password,
					customer_password_confirmation: this.customer_password_confirmation,
					customer_network_mid: this.customer_network_mid,
				}
				this.$emit('action', params)
			}
		},
		showPassword() {
			if (this.inputType == 'password') {
				this.iconPass = 'mdi-eye-off'
				this.inputType = 'text'
			} else {
				this.iconPass = 'mdi-eye'
				this.inputType = 'password'
			}
		},
		showPasswordConfirmation() {
			if (this.inputTypeConfirmation == 'password') {
				this.iconPass = 'mdi-eye-off'
				this.inputTypeConfirmation = 'text'
			} else {
				this.iconPass = 'mdi-eye'
				this.inputTypeConfirmation = 'password'
			}
		}
	},
}
</script>
